import { gsap } from'gsap';
import { ScrollTrigger } from'gsap/ScrollTrigger';
import { ScrollToPlugin } from'gsap/ScrollToPlugin';
import { TextPlugin } from'gsap/TextPlugin';
import { Flip } from'gsap/Flip';
import { CustomEase } from'gsap/CustomEase';
import { MotionPathPlugin } from'gsap/MotionPathPlugin';

// Register all FREE GSAP plugins
gsap.registerPlugin(
 ScrollTrigger,
 ScrollToPlugin,
 TextPlugin,
 Flip,
 CustomEase,
 MotionPathPlugin
);

// Global GSAP defaults
gsap.defaults({
 ease:'power3.out',
 duration: 1,
});

// Custom eases
CustomEase.create('smoothOut','0.19, 1, 0.22, 1');
CustomEase.create('bounceIn','0.68, -0.55, 0.265, 1.55');
CustomEase.create('elasticOut','0.175, 0.885, 0.32, 1.275');
CustomEase.create('expoOut','0.16, 1, 0.3, 1');

// ScrollTrigger defaults
ScrollTrigger.defaults({
 toggleActions:'play none none reverse',
 start:'top 80%',
});

export {
 gsap,
 ScrollTrigger,
 ScrollToPlugin,
 TextPlugin,
 Flip,
 CustomEase,
 MotionPathPlugin,
};

export default gsap;